import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';

export interface IAppUserSearchResult {
    id: number;
    name: string;
    cpf: string;
    phone: string;
    email: string | null;
}

export interface IIptuUserSearchResult {
    id: number;
    name: string;
    cpfCnpj: string;
    countyId: number;
}

export interface ICitySearchResult {
    id: number;
    name: string;
    city: string;
    uf: string;
    cnpj: string;
}

export interface IGiveawaySearchResult {
    id: number;
    description: string | null;
    type: string;
    status: string;
    dateOfRaffle: string;
    countyId: number;
}

export interface ICompanySearchResult {
    id: string | number;
    name: string;
    cnpj: string | null;
    city?: string | null;
    uf?: string | null;
    countyId?: number;
}

export interface IGlobalSearchResponse {
    app_users: IAppUserSearchResult[];
    iptu_users: IIptuUserSearchResult[];
    cities: ICitySearchResult[];
    giveaways: IGiveawaySearchResult[];
    companies: ICompanySearchResult[];
}

export interface IGlobalSearchParams {
    q: string;
    cityId?: number;
    category?: string;
    limit?: number;
    signal?: AbortSignal;
}

class SearchService {
    private baseURL: string = `${urlHttpGov}/panel/search`;

    async search({ q, cityId, category = 'all', limit = 5, signal }: IGlobalSearchParams): Promise<IGlobalSearchResponse> {
        const params: Record<string, any> = {
            q,
            category,
            limit,
        };

        if (cityId !== undefined && cityId !== null) {
            params.cityId = cityId;
        }

        const { data } = await privateHttpClient.get<IGlobalSearchResponse>(this.baseURL, {
            params,
            signal,
        });

        return data;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SearchService();
